// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Paso1 test Match con el snapshot 1`] = `""`;
